import ApiResourceManager from '../ApiResourceManager';

export default class ReservationMediaManager extends ApiResourceManager {
  ON_BEHALF_OF_COMPANY = 'reservation-on-behalf-of-company';

  get = () =>
    this.request({
      method: 'GET',
      url: '/merchant/scripts',
    });

  post = (data) =>
    this.request({
      method: 'POST',
      url: '/merchant/scripts',
      data,
    });

  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/merchant/scripts/${id}`,
      data,
    });

  delete = (scriptId) =>
    this.request({
      method: 'DELETE',
      url: `/merchant/scripts/${scriptId}`,
    });
}
